// extracted by mini-css-extract-plugin
export default {"popupTitle":"LoginMultifactorAuthenticationPopup_popupTitle__QTuJb","footerContainer":"LoginMultifactorAuthenticationPopup_footerContainer__IvRL5"};